// import Swal from "sweetalert2";

// export default function useAlert() {
//   const showAlert = ({
//     title,
//     text,
//     icon,
//     html,
//     showConfirmButton = true,
//     showCancelButton = false,
//     confirmButtonText = "OK",
//     cancelButtonText = "Cancel",
//     confirmButtonColor = "#d33",
//     cancelButtonColor = "#3085d6",
//     timer,
//     confirmCb,
//     cancelCb,
//     fullscreen = false,
//   }) => {
//     Swal.close();
//     Swal.fire({
//       title,
//       text,
//       icon,
//       html,
//       showConfirmButton,
//       showCancelButton,
//       confirmButtonText,
//       cancelButtonText,
//       confirmButtonColor,
//       cancelButtonColor,
//       timer,
//       ...(fullscreen
//         ? {
//             grow: "fullscreen",
//             width: "100%",
//             height: "100vh",
//             customClass: {
//               popup: "swal-fullscreen",
//               container: "swal-fullscreen-container",
//             },
//           }
//         : {}),
//     }).then((result) => {
//       if (result.isConfirmed) {
//         console.log("confirmed");
//         if (confirmCb) confirmCb();
//       } else if (result.isDismissed) {
//         console.log("canceled");
//         if (cancelCb) cancelCb();
//       }
//     });
//   };

//   return {
//     showAlert,
//   };
// }
import Swal from "sweetalert2";

export default function useAlert() {
  const messageQueue = [];
  let isProcessing = false;

  const processQueue = () => {
    if (isProcessing || messageQueue.length === 0) return;

    const {
      title,
      text,
      icon,
      html,
      showConfirmButton = true,
      showCancelButton = false,
      confirmButtonText = "OK",
      cancelButtonText = "Cancel",
      confirmButtonColor = "#d33",
      cancelButtonColor = "#3085d6",
      timer, // 若沒按鈕才有用
      confirmCb,
      cancelCb,
      fullscreen = false,
    } = messageQueue.shift();

    isProcessing = true;

    const autoClose = !showConfirmButton; // 無確認按鈕就自動關閉
    const effectiveTimer = autoClose ? timer || 3000 : undefined;

    Swal.fire({
      title,
      text,
      icon,
      html,
      showConfirmButton,
      showCancelButton,
      confirmButtonText,
      cancelButtonText,
      confirmButtonColor,
      cancelButtonColor,
      timer: effectiveTimer,
      ...(fullscreen
        ? {
            grow: "fullscreen",
            width: "100%",
            height: "100vh",
            customClass: {
              popup: "swal-fullscreen",
              container: "swal-fullscreen-container",
            },
          }
        : {}),
    }).then((result) => {
      isProcessing = false;

      if (result.isConfirmed) {
        confirmCb?.();
      } else if (result.isDismissed) {
        cancelCb?.();
      }

      // 等 200ms 再跳下一則
      setTimeout(() => processQueue(), 200);
    });
  };

  const showAlert = (options) => {
    messageQueue.push(options);
    processQueue();
  };

  const isVisible = () => Swal.isVisible();

  return {
    showAlert,
    isVisible,
  };
}